import styled from 'styled-components'

export default styled.article`
  display: flex;
  height: 100%;
  width: 100vw;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
  box-sizing: border-box;

  header {
    flex: 0;
    margin-bottom: 25px;
    align-items: center;
    text-align: center;

    img.logoAmb {
      max-width: 365px;
    }
    
    img.logoNemiRounded {
      max-width: 100px;
      margin-bottom: 50px;
    }
  }

  form {
    width: 515px;
    flex: 1;
    border-radius: 20px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    padding: 70px 90px;
    box-sizing: border-box;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    background-color: ${ ({ theme }) => theme.colors.white };

    .link {
      text-align: center;

      span {
        color: ${ ({ theme }) => theme.colors.primary };
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 15px;
        text-align: center;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .actions {
      margin-top: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 5px;

      .link {
        margin-top: 30px;
      }
    }

    .error-container {
      flex-direction: row;
      justify-content: center;
      margin-top: 25px;
      width: 100%;
      text-align: center;
      align-self: center;

      .error {
        color: ${ ({ theme }) => theme.colors.red };
        text-align: center;
      }
    }
  }
`
